const remove_markdown_space_newline = (text: string): string => {
  return text.replace(/[\{]+([^\|\｜]+)([\|\｜](.+?\}+))+|(^\s+|\s+$|\s+(?=\s))|(\r?\n|\r)/g, '$1');
};

const remove_hash_tag = (text: string): string => {
    return text.replace(/^(#|＃)(.*?)(#|＃)$/g, '$2');
}

const convertFullToHalfWidth = (fullWidth: string):string => {
    let halfWidth:string = "";
    const len = fullWidth.length;
    for(let i=0; i<len; i++){
        let c:number = fullWidth.charCodeAt(i);
        if(c == 12288) { // 全角スペースを半角スペースに変更
            halfWidth += String.fromCharCode(32);
            continue;
        }
        if(c == 12289){ // 「、」を半角に変更
            halfWidth += String.fromCharCode(44);
            continue;
        }
        if(c == 12290){ // 「。」を半角に変更
            halfWidth += String.fromCharCode(46);
            continue;
        }
        if(c==8316 || c==8332 || c==12448 || c==42890 || c==65126 || c==65309 || c==11840){
            //「⁼ ₌ ゠ ꞊ ﹦＝ ⹀」 → 「=」等号、ダブルハイフンを半角記号に変更
            halfWidth += String.fromCharCode(61);
            continue;
        }
        if(c==65374 || c==12316 || c==126){
            //「～ 〜 ~」 →　「∼」波記号を半角波記号に変更
            halfWidth += String.fromCharCode(8764);
            continue;
        }
        if(c > 65280 && c < 65375){ // 半角に変更 (33-126)
            halfWidth += String.fromCharCode(c - 65248);
            continue;
        }
        if(c == 10){ // 改行はスルー
            continue;
        }
        halfWidth += String.fromCharCode(c);
    }
    // 渡す前前後スペース除去
    halfWidth = halfWidth.replace(/(^\s+)|(\s+$)/g, "");
    // 連続のスペースを一つのスペースに変更
    halfWidth = halfWidth.replace(/  +/g, " ");
    // 数字の間にコンマを除去
    halfWidth = convertNumber(halfWidth);
    halfWidth = remove_hash_tag(halfWidth)
    // convert roman number to alphabet characters with similar glyphs
    halfWidth = romanToAlphabets(halfWidth)
    // 特定のUnicodeの丸記号を漢字の「〇」に変換
    halfWidth = convertCircle(halfWidth)
    return halfWidth;
};

const contractionsDictionary = {
    "aren't": "are not",
    "can't": "cannot",
    "couldn't": "could not",
    "didn't": "did not",
    "doesn't": "does not",
    "don't": "do not",
    "hasn't": "has not",
    "haven't": "have not",
    "he'll": "he will",
    "here's": "here is",
    "he's": "he is",
    "how's": "how is",
    "I'd": "I would",
    "I'll": "I will",
    "I'm": "I am",
    "isn't": "is not",
    "it'll": "it will",
    "it's": "it is",
    "I've": "I have",
    "let's": "let us",
    "mustn't": "must not",
    "she'll": "she will",
    "she's": "she is",
    "shouldn't": "should not",
    "that's": "that is",
    "there're": "there are",
    "there's": "there is",
    "they'll": "they will",
    "they're": "they are",
    "they've": "they have",
    "wasn't": "was not",
    "we'd": "we would",
    "we'll": "we will",
    "we're": "we are",
    "weren't": "were not",
    "we've": "we have",
    "what's": "what is",
    "when's": "when is",
    "where's": "where is",
    "who's": "who is",
    "won't": "will not",
    "wouldn't": "would not",
    "you'll": "you will",
    "you're": "you are",
    "you've": "you have",
    "should've": "should have",
    "could've": "could have",
    "would've": "would have",
    "might've": "might have",
    "must've": "must have",
    "why's": "why is",
    "hadn't": "had not",
    "mightn't": "might not",
    "Don't": "Do not",
    "He'll": "He will",
    "Here's": "Here is",
    "He's": "He is",
    "How's": "How is",
    "It'll": "It will",
    "It's": "It is",
    "Let's": "Let us",
    "Mustn't": "Must not",
    "She'll": "She will",
    "She's": "She is",
    "That's": "That is",
    "There're": "There are",
    "There's": "There is",
    "They'll": "They will",
    "They're": "They are",
    "They've": "They have",
    "We'd": "We would",
    "We'll": "We will",
    "We're": "We are",
    "We've": "We have",
    "What's": "What is",
    "When's": "When is",
    "Where's": "Where is",
    "Who's": "Who is",
    "You'll": "You will",
    "You're": "You are",
    "You've": "You have",
    "Why's": "Why is",
};
// NFR-5319: check the number of word is more than one or not
function isMultipleWords(text: string): boolean {
    // Trim the text to remove any leading or trailing spaces
    // Split the text by spaces and filter out any empty strings
    const words = text.trim().split(/\s+/);
    return words.length > 1;
}
// NFR-5319: expand abbreviation word
function expandContractions(text: string) {
    if(isMultipleWords(text)){
        return text.replace(/\b\w+(?:'\w+)+\b/g, function(match) {
            return contractionsDictionary[match] || match;
        });
    }
    return text
}

const englishNormalization = (fullWidth: string) => {
    let halfWidth = "";
    const len = fullWidth.length;
    for(let i=0; i<len; i++){
        let c = fullWidth.charCodeAt(i);
        if(c == 12288) { // 全角スペースを半角スペースに変更
            halfWidth += String.fromCharCode(32);
        }
        else if(c == 12289){ // 「、」を半角に変更
            halfWidth += String.fromCharCode(44);
        }
        else if(c == 12290){ // 「。」を半角に変更
            halfWidth += String.fromCharCode(46);
        }
        else if(c==8316 || c==8332 || c==12448 || c==42890 || c==65126 || c==65309 || c==11840){
            //「⁼ ₌ ゠ ꞊ ﹦＝ ⹀」 → 「=」等号、ダブルハイフンを半角記号に変更
            halfWidth += String.fromCharCode(61);
        }
        else if(c==12316 || c===65374 || c===126){
            //「〜 ～ ~」 →　「∼」波記号を半角波記号に変更
            halfWidth += String.fromCharCode(8764);
        }
        else if(c==8208|| c==8211 || c==8212 || c==8213 || c==12540){
            // 「‐ – — ― ー」→ 「-」ハイフン、ダッシュ、長母音を半角記号に変更
            halfWidth += String.fromCharCode(45);
        }
        else if(c==8220 || c==8221){
            // 「“ ”」→ 「"」ダブルクォートを半角記号に変更
            halfWidth += String.fromCharCode(34);
        }
        else if(c==8943){
            // 「⋯」→ 「…」エリプシスを半角記号に変更
            halfWidth += String.fromCharCode(8230);
        }
        else if(c > 65280 && c < 65375){ // 半角に変更 (33-126)
            halfWidth += String.fromCharCode(c - 65248);
        }
        else if(c == 10){ // 改行はスルー
        }
        else{
            halfWidth += String.fromCharCode(c);
        }
    }
    // 渡す前前後スペース除去
    halfWidth = halfWidth.replace(/(^\s+)|(\s+$)/g, "");
    // 連続のスペースを一つのスペースに変更
    halfWidth = halfWidth.replace(/\s\s+/g, " ");
    // 数字の間にコンマを除去
    halfWidth = convertNumber(halfWidth);
    // エリプシス「...」これは一つの記号ではないので別に変更する
    halfWidth = halfWidth.replace(/[.]{3}/g, "…");
    // アポストロフィを正規化
    halfWidth = convertDashApostrophe(halfWidth);
    halfWidth = remove_hash_tag(halfWidth)
    halfWidth = normalizeShortName(halfWidth)
    // convert roman number to alphabet characters with similar glyphs
    halfWidth = romanToAlphabets(halfWidth)
    // expand abbreviation
    halfWidth = expandContractions(halfWidth)
    // 特定のUnicodeの丸記号を漢字の「〇」に変換
    halfWidth = convertCircle(halfWidth)
    return halfWidth;
}

const societyNormalization = (text: string):string => {
    // 社会専用：区切り文字 = ・を半角スペースに変更
    text = text.replace(/(=|・|･)/g, " ");
    // NFR-5323: Case insensitive for alphabetical answers
    text = text.toUpperCase()
    return text
}

const deleteEmptySpace = (text:string):string => {
    // 半角全角スペースを除去する
    text = text.replace(/( |　)+/g, "");
    return text
}


const normalizeShortName = (text: string): string=> {
    /* remove one or more space after .|,|'|!|?
    i.e. That is Ms. Cook. ⇒ That is Ms.Cook.*/
    text = text.replace(/([.,'!?][\s]+)/g, function(match_text){
        return match_text[0]
    });
    /* remove one or more space before .|,|'|!|?
    i.e.  Who  's that? ⇒ Who's that?*/
    return text.replace(/([\s]+[.,'!?])/g, function(match_text){
        return match_text[1]
    })
}

const convertDashApostrophe = (text:string): string => {
    // 数学・理科、英語で「´、’、′、‘、＇、`、ʼ」→「'」半角記号に変更(NFR-2989)
    text = text.replace(/(´|’|′|‘|＇|`|ʼ)+/g, "'")
    // shift key + number 7 keyを押すと数学のダッシュ記号(latex)の「^{\prime}」に変わる。その対応（数学、理科のみ）
    text = text.replace(/\^{\\prime}/g, "'");
    return text
}

const convertNumber = (text: string): string => {
    // remove , between a number of string　‘price is 10,0000$’ ⇒ ‘price is 100000$’
    return text.replace(/([0-9]+)[,]([0-9]+)[,]?/g, function(match_text){
        return match_text.replace(/(,)/g, '')
    });
}

const SUPER_SCRIPT_DICT = {'\u2070': '0', '\u00B9': '1', '\u00B2': '2', '\u00B3': '3', '\u2074': '4', '\u2075': '5', '\u2076': '6', '\u2077': '7', '\u2078': '8', '\u2079': '9', '\u207A': '+', '\u207B': '-'}

const convertSupscript = (text: string): string => {
    return text.replace(/[\u2074-\u207B\u00B2-\u00B3\u00B9\u2070]+/g, function(match_text) {
        let result = "^";
        const len = match_text.length;
        if(len>1){
            result += "{"
        }
        for(let i=0; i<len; i++){
            result += SUPER_SCRIPT_DICT[match_text[i]]
        }
        if(len>1){
            result += "}"
        }
        return result;
    })
}

const SUB_SCRIPT_DICT = {'\u2080': '0', '\u2081': '1', '\u2082': '2', '\u2083': '3', '\u2084': '4', '\u2085': '5', '\u2086': '6', '\u2087': '7', '\u2088': '8', '\u2089': '9', '\u208A': '+', '\u208B': '-'}

const convertSubscript = (text: string): string => {
    return text.replace(/[\u2080-\u208B]+/g, function(match_text) {
        let result = "_";
        const len = match_text.length;
        if(len>1){
            result += "{"
        }
        for(let i=0; i<len; i++){
            result += SUB_SCRIPT_DICT[match_text[i]]
        }
        if(len>1){
            result += "}"
        }
        return result;
    })
}

const convertUnitSymbols = (text: string): string => {
    text = text.replace(/㎏/g, "kg");
    text = text.replace(/㎜/g, "mm");
    text = text.replace(/㎝/g, "cm");
    text = text.replace(/㎞/g, "km");
    text = text.replace(/㎠/g, "cm^2");
    text = text.replace(/㎤/g, "cm^3");
    text = text.replace(/㎡/g, "m^2");
    text = text.replace(/㎥/g, "m^3");
    text = text.replace(/㎩/g, "Pa");
    text = text.replace(/㍱/g, "hPa");
    text = text.replace(/㎃/g, "mA");
    text = text.replace(/Ω/g, "Ω");
    text = text.replace(/㎐/g, "Hz");
    text = text.replace(/㎧/g, "m/s");
    text = text.replace(/㎾/g, "kW");
    text = text.replace(/㏗/g, "pH");
    return text
}

const convertSubSuperscriptNested = (text:string): string =>{
    // NFR-7381: 3つ目のグループの末尾を「符号1つ＋英数字」に限定し、2つ目の符号（例: Cu^2^++2Cl の反応式「+」）以降を巻き込まないようにする。符号の後ろに続く数字（例: X^a^-2 → X^{a-2}）は取り込む。
    // NFR-7409: 2つ目のキャレット直後の符号（+/-）を必須にし、符号を伴わない数式の独立した指数（例: x^3y^2）を結合しないようにする。
    return text.replace(/([A-Za-z0-9]+\_|)([A-Za-z0-9]+\^)([A-Za-z0-9]+\^[\+\-][A-Za-z0-9]*)/g, function(match_text, first_match, second_match, third_match){
        let result = ""
        for(let i = 0; i < third_match.length; i++){
            if(third_match[i] !== '^'){
                result += third_match[i]
            }
        }
        return `${first_match}${second_match}{${result}}`
    })
}
// convert nested power ab^{cd^{ef}} to ab^{cdef}
const convertNestedPower = (text: string): string => {
    return text.replace(/([A-Za-z0-9]+\^)({.+?}+)/g, function(match_text, first_match, second_match){
        let result = ""
        for(let i=0; i<second_match.length; i++){
            if(second_match[i] !=='{' && second_match[i] !== '}' && second_match[i] !== '^'){
                result += second_match[i]
            }
        }
        return `${first_match}{${result}}`
    })
}

// NFR-7419 連続した同種スクリプトを統合する（二重上付き ^x^y → ^{xy} / 二重下付き _x_y → _{xy}）。
// convertSubSuperscriptNestedはbase必須で、先頭のbaseなし二重上付き（例 ^-^4）や二重下付き（例 _1_2）を取りこぼしていた対応。
const convertConsecutiveScripts = (text: string): string => {
    // 1スクリプト分の中身: 括弧付き / LaTeXコマンド(\circ 等) / 1文字。\単体を取り込むとコマンドが括弧外に残り壊れるため除外
    const script = "(\\{[^{}]*\\}|\\\\[A-Za-z]+|[^\\s\\\\{}^_])"
    const regex = new RegExp(`([\\^_])${script}\\1${script}`)
    const unwrap = (raw: string): string => raw.startsWith("{") ? raw.slice(1, -1) : raw
    // 3連続以上（例 ^a^b^c）にも対応するため、変化がなくなるまで繰り返す
    let prev = ""
    while (prev !== text) {
        prev = text
        text = text.replace(regex, (_m, mark, first, second) => `${mark}{${unwrap(first)}${unwrap(second)}}`)
    }
    return text
}

// NFR-7419 mhchem（\ce）はベースを持たない「上付き→下付き」の並びを下付き優先に並べ替えて出力するため
// （\ce{^{+}_{2}} は「₂⁺」と表示される）、空グループ{}を挟んで別々のスクリプトとして描画させ入力順を保つ。
// 表示専用。採点側（convertLatex）に入れると{}が登録解答と一致しなくなるためnormalizeNestedScriptには含めない。
// 前提: \ceで囲む理科の化学式表示専用。直後の英字を「元素記号」とみなす判定（下記followedByLetter）が
// この前提に依存しているため、\ce以外（一般的な数式表示など）で流用する場合は判定の見直しが必要。
const separateBaselessScriptPair = (text: string): string => {
    // 1スクリプト分の中身: 括弧付き / LaTeXコマンド(\circ 等) / 1文字
    const script = "(?:\\{[^{}]*\\}|\\\\[A-Za-z]+|[^\\s\\\\{}^_])"
    // ベースを持たない位置（先頭、または英数字・各種閉じ括弧以外の直後）から始まるスクリプトの連なりをまとめて処理する。
    // ペア単位で置換すると連続したペア（例 ^+_2^-_3）の2組目以降を取りこぼすため、連なり単位でマッチさせる。
    // ベースあり（例 H^{+}_{2}）はmhchemが重ね表示するため、そもそも連なりの開始位置にならない。
    // 多原子イオン（例 (OH)^-_2 / [Cu(NH_3)_4]^{2+}_{3}）も「)」「]」がベースとして重ね表示されるため対象外にする。
    const runRegex = new RegExp(`(^|[^A-Za-z0-9})\\]])((?:[\\^_]${script})+)`, "g")
    const scriptRegex = new RegExp(`[\\^_]${script}`, "g")
    return text.replace(runRegex, (matched: string, prefix: string, run: string, offset: number) => {
        const scripts = run.match(scriptRegex) ?? []
        // 連なりの直後が英字（＝\ceでは元素記号）の場合、末尾のペアはその原子の前置スクリプト
        // （例 ^{227}_{90}Th）であり重ね表示が正しいため分離しない
        const followedByLetter = /[A-Za-z]/.test(text.charAt(offset + matched.length))
        const separableUntil = followedByLetter ? scripts.length - 1 : scripts.length
        let result = prefix
        scripts.forEach((current, index) => {
            result += current
            const next = scripts[index + 1]
            if (index + 1 < separableUntil && current.startsWith("^") && next.startsWith("_")) {
                result += "{}"
            }
        })
        return result
    })
}

// NFR-7306 ネストした上付き/下付き（例 $Mg^{^2^+}$ → $Mg^{2+}$）を採点時と同じ形に正規化し、表示側の二重上付き文字崩れを防ぐ
const normalizeNestedScript = (text: string): string => {
    // NFR-3670対応　$SO_4^2^-$ -> $SO_4^{2-}$ / $SO^2^+$ -> $SO^{2+}$
    text = convertSubSuperscriptNested(text)
    // ab^{cd^{ef}} -> ab^{cdef}
    text = convertNestedPower(text)
    // NFR-7419 baseなし先頭の二重上付き・二重下付き（例 ^-^4 / _1_2）を統合する
    text = convertConsecutiveScripts(text)
    return text
}

const ROMAN_TO_ALPHABET_DICT = {
    "Ⅰ": "I",
    "Ⅴ": "V",
    "Ⅹ": "X",
    "Ⅼ": "L",
    "Ⅽ": "C",
    "Ⅾ": "D",
    "Ⅿ": "M",
    "ⅰ": "i",
    "ⅴ": "v",
    "ⅹ": "x",
    "ⅼ": "l",
    "ⅽ": "c",
    "ⅾ": "d",
    "ⅿ": "m" 
}

const romanToAlphabets = (text: string): string => {
    return text.replace(/[ⅠⅤⅩⅬⅭⅮⅯⅰⅴⅹⅼⅽⅾⅿ]+/g, function(match_text){
        let result = ""
        const len = match_text.length
        for(let i=0; i<len; i++){
            result += ROMAN_TO_ALPHABET_DICT[match_text[i]]
        }
        return result
    })
}

const CIRCLE_DICT = {
    '\u25EF': '\u3007', // ◯ Large Circle
    '\u25CB': '\u3007', // ○ White Circle
    '\u20DD': '\u3007', // ◌ Combining Enclosing Circle
    '\u2B58': '\u3007', // ⭘ Heavy Large Circle
    '\u26AA': '\u3007', // ⚪ Medium White Circle
    '\u2B55': '\u3007', // ⭕ Heavy Large Circle with Check
    '\u25CC': '\u3007', // ◌ Dotted Circle
}

// NFR-6095 対応: 特定のUnicodeの丸記号を漢字の「〇」に変換する関数
const convertCircle = (text: string): string => {
    const circleChars = Object.keys(CIRCLE_DICT).join('');
    const regex = new RegExp(`[${circleChars}]+`, 'g');
    // 入力された文字列に対して正規表現による置換処理を行う
    return text.replace(regex, function(match_text){
        let result = ""
        const len = match_text.length
        for(let i=0; i<len; i++){
            result += CIRCLE_DICT[match_text[i]]
        }
        return result
    }).replace(/[\ufe0f\ufe0e]/g, ''); // U+FE0FおよびU+FE0Eを削除する（絵文字の表示制御文字）
}

const convertLatex = (text: string): string => {
    // 全角を半角に変更
    text = convertFullToHalfWidth(remove_markdown_space_newline(text))
    // アポストロフィを正規化
    text = convertDashApostrophe(text)
    if (text.includes("\\ce")) { // 化学式で使うコマンド\ce{}（問題登録する時は全部付ける）
        // \ceと{ 最初の括弧削除
        const text_len = text.length
        text = text.replace(/(\\ce)[{]*/g, "")
        // find how many close curly braces(}) need to delete
        const text_len_diff = text_len - (text.length + 3)
        const regex = new RegExp(`(}{${text_len_diff}}\\$)$`, "g");
        // } 一番最後の括弧削除(正答が分数がある場合{}括弧が複数なので一括で削除するとだめ、一番外の{}括弧だけ削除)
        text = text.replace(regex, "$")
        // \ceコマンドを使う時は下付き数字で'_'付ける必要がないため正規化する時'_'付ける変換が必要
        text = text.replace(/([A-Za-z])([0-9])/g, "$1_$2")
    }
    // 「2⁰¹²³⁴ ⇒ 2^{01234}, 2⁴ ⇒ 2^4」　上付き数字を正規化する
    text = convertSupscript(text)
    // 「2₁₂₃₄₅₆₇₈₉₀ ⇒ 2_{1234567890}, H₂O ⇒ H_2O」　下付き数字を正規化する
    text = convertSubscript(text)
    // NFR-3670対応 $SO_4^2^-$ -> $SO_4^{2-}$ 等。NFR-7306 表示側と同じヘルパーで採点/表示のネスト正規化がずれないようにする
    text = normalizeNestedScript(text)
    // textの前後のスペースと連続スペースは除去しているが、途中のスペース除去はしてないので追加(\ceコマンドで記号前後に半角空白が付けられることの対応も含む)
    // 例えば、正答登録が $0 \leqq y \leqq 20$で, ユーザーの解答が $0\leqq y\leqq20$ こうなると比較するため空白削除が必要。
    // 正答登録で空白が細かく入る可能性があるため全部削除して下の正規化で必要に応じて空白を入れる。
    text = text.replace(/\s/g, "")
    // NFR-2644 ユーザー解答入力する時数学、理科のみスペースは「\\:」この表示になるのでテキストにある場合除去する
    text = text.replace(/(\\:)/g, "")
    // NFR-7309 MathLiveが「+」を「\+」とエスケープ出力する場合があるため登録解答の素の「+」と一致するようバックスラッシュを除去する
    text = text.replace(/\\\+/g, "+")
    // NFR-7309 1文字だけの下付き/上付き括弧（例 H_{2} → H_2）を外し、登録解答（\ceは素の下付き）と一致させる。複数文字（^{2-} 等）は対象外
    text = text.replace(/([_^])\{([^{}])\}/g, "$1$2")
    // NFR-3083 full-width space(Japanese keyboard) remove
    text = text.replace(/(\\quad)/g, "")
    // 分数で「\\displaystyle」ある場合除去する
    text = text.replace(/(\\displaystyle)[ ]*/g, "")
    // convert dfact to fact(NFR-2120)
    text = text.replace(/(\\dfrac)/g, "\\frac")
    // 「単位の特殊記号」を正規化する
    text = convertUnitSymbols(text)
    // 「l, 𝐥, \\ell」を正規化する + latexコマンドで「l」が入るコマンドがあるのでその文字列は\ellに変更しないように除外
    text = text.replace(/(l(?!e|o)|𝐥|\\ell)/g, "\\ell")
    // NFR-7309 mhchem「->」とキーボードの「→」「\rightarrow」「\to」を統一する。「\right」が「\rightarrow」を壊すため「\left/\right」正規化より前に実行
    text = text.replace(/(->|\\rightarrow|\\to|→)/g, "\\longrightarrow")
    // 「左括弧」を正規化する
    text = text.replace(/\\left\(|\\left/g, "(")
    // 「右括弧」を正規化する
    text = text.replace(/\\right\)|\\right/g, ")")
    // \geqq,\leqqの後ろにアルファベットが来た場合(20 \geqq x)は必ず空白が必要。数字は空白があってもなくても関係ない。
    //　上記でtextの中での空白を削除したので\geqq, \leqqの後ろに空白をいれる。APIで正誤判定する場合があるので必要
    // 「>= , ≧ , ≥ , ⩾ , \geqq」を正規化する
    text = text.replace(/(>=|≧|≥|⩾|\\geqq)/g, "\\geqq ")
    // 「<= , ≦ , ≤ , ⩽ , \leqq」を正規化する
    text = text.replace(/(<=|≦|≤|⩽|\\leqq)/g, "\\leqq ")
    // 「\\sim, 〜, ～, ~, ∼」を正規化する
    text = text.replace(/(\\sim|〜|～|~|∼|∽)/g, "\\backsim")
    // 「＋, ✙, ✚, ✛, ➕」を正規化する
    text = text.replace(/(＋|✙|✚|✛|➕)/g, "+")
    // 「‐, ー, ―, −」を正規化する
    text = text.replace(/(‐|ー|―|−)/g, "-")
    // 「*, ×, ✖, ❌, ✕, \\times」を正規化する
    text = text.replace(/(\*|×|✖|❌|✕|\\times)/g, "\\times ")
    // 「÷, /, \div」を正規化する
    text = text.replace(/(\/|÷|\\div)/g, "\\div ")
    // 「三角形, △, \\triangle」を正規化する
    text = text.replace(/(三角形|△|\\triangle)/g, "\\triangle ")
    // 「角, ∠, \\angle」を正規化する
    text = text.replace(/(角|∠|\\angle)/g, "\\angle ")
    // 「±」を正規化する
    text = text.replace(/±/g, "\\pm");
    // 「√」を正規化する
    text = text.replace(/[√]([0-9]*)/g, "\\sqrt{$1}")
    // 「≡」を正規化する
    text = text.replace(/≡/g, "\\equiv");
    // 「π, Π」を正規化する
    text = text.replace(/(π|Π)/g, "\\pi")
    // 「-2\frac{2}{3} ⇒ -2+-\frac{2}{3}」を正規化する
    text = text.replace(/([-][0-9]+)[\{]?([\\][frac]+[\{][\d]+[\}][\{][\d]+[\}])[\}]?/g, "($1+-$2)")
    // 「2\frac{2}{3} ⇒ 2+\frac{2}{3}」を正規化する
    text = text.replace(/([+]*[0-9]+)[\{]?([\\][frac]+[\{][\d]+[\}][\{][\d]+[\}])[\}]?/g, '($1+$2)')
    // NFR-5476 「⊥」(\bot)を\perpに正規化する
    text = text.replace(/\\bot/g, "\\perp");
    // NFR-5476 「°」を^{\circ}に正規化する
    text = text.replace(/\\degree/g, "^{\\circ}");
    // NFR-5476 「℃」を{n}^\circ\mathrm{C}に正規化する
    text = text.replace(/(\d+)\s*℃/g, "\\{$1}^\\circ\\mathrm{C}");
    // remove $ for markdown view
    text = text.replace(/[\$]+/g, '')
    return text.trim()
}
// NFR-5411: remove floating-point numbers trailing zeros
const cleanFloatingNumbers = (input: string): string =>{
    // Match floating-point numbers using a regex
    return input.replace(/\b\d+\.\d+0*\b/g, (match) => {
      // Remove trailing zeros from the matched number
      return parseFloat(match).toString();
    });
}
  
export {
    remove_markdown_space_newline,
    remove_hash_tag,
    romanToAlphabets,
    convertUnitSymbols,
    convertDashApostrophe,
    convertSubSuperscriptNested,
    convertNestedPower,
    convertConsecutiveScripts,
    separateBaselessScriptPair,
    normalizeNestedScript,
    convertFullToHalfWidth,
    normalizeShortName,
    convertNumber,
    convertLatex,
    englishNormalization,
    societyNormalization,
    deleteEmptySpace,
    convertSupscript,
    convertSubscript,
    isMultipleWords,
    expandContractions,
    cleanFloatingNumbers,
    convertCircle
};

